<template>
  <v-form v-model="isAccountFormValid">
    <ShopAccountField
      v-for="field of fields"
      :key="field.id"
      :field="field"
      @update="updateUserEntity({ [field.name]: $event })"
    />
    <v-btn
      @click="persistUserData"
      :loading="saving"
      depressed
      :disabled="saving || !modifiedFieldNames.length"
      class="d-inline"
      color="blue darken-2 white--text"
      >Save</v-btn
    >
    <v-btn
      @click="reset"
      depressed
      :disabled="saving || !modifiedFieldNames.length"
      class="d-inline ml-2"
      outlined
      color="blue darken-2 white--text"
      >Cancel Changes</v-btn
    >
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { mapFields } from 'vuex-map-fields'

import ShopAccountField from '@/components/ShopAccountField'

export default {
  name: 'ManageAccountForm',
  components: { ShopAccountField },
  data() {
    return {
      saving: false,
      error: false,
      isAccountFormValid: false,
      originalUser: {},
      fields: [
        {
          label: 'First Name',
          name: 'first_name',
          type: 'textShort',
          rules: ['requiredString'],
        },
        {
          label: 'Last Name',
          name: 'last_name',
          type: 'textShort',
        },
        {
          hint: 'The email you use to login to this portal',
          label: 'Your Email',
          name: 'email',
          type: 'email',
          rules: ['emailRule'],
        },
      ],
    }
  },
  created() {
    this.originalUser = this.authUser
  },
  methods: {
    ...mapActions('auth', ['updateMerchantUser']),
    reset() {
      this.authUser = this.originalUser
    },
    updateUserEntity(changes) {
      this.authUser = { ...this.authUser, ...changes }
    }, // updateUserEntity
    async persistUserData() {
      let changes = {}

      this.modifiedFieldNames.forEach((fieldName) => {
        changes[fieldName] = this.authUser[fieldName]
      })
      await this.updateMerchantUser(changes)
      this.originalUser = await this.authUser
    }, // persistUserData
  },
  computed: {
    ...mapGetters('auth', ['getAuthUserId']),
    ...mapFields('auth', { authUser: 'user' }),
    modifiedFieldNames() {
      return this.fields
        .filter(
          (field) => this.authUser[field.name] !== this.originalUser[field.name]
        )
        .map((f) => f.name)
    }, // modifiedFieldNames
  },
}
</script>
